function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function ($) {
  var Repeater_Radio_With_Unique_Value = /*#__PURE__*/function () {
    "use strict";

    /**
     * @param {object jQuery} $unique_radio_repeater_cell Should have classes `gfield_repeater_cell gf-unique-radio-field-value` 
     *                                                    Also, give it a default class (won't work otherwise) : `unique-default-is-` (add any value at the end that match a radio button value)
     *                                                    It must be a clear and unique cell.
     * @param {string} id Make sure its unique.
     */
    function Repeater_Radio_With_Unique_Value($unique_radio_repeater_cell, id) {
      _classCallCheck(this, Repeater_Radio_With_Unique_Value);
      this.$repeater_field = $unique_radio_repeater_cell.parents('.gfield--repeater');
      this.repeater_cell_classes = $unique_radio_repeater_cell.attr('class');
      this.id = id;
      this.default_value = this.get_default_value_from_repeater_cell_classes();
      this.init_change_event();
    }
    return _createClass(Repeater_Radio_With_Unique_Value, [{
      key: "init_change_event",
      value: function init_change_event() {
        var _this = this;
        this.$repeater_field.on('change', "[data-cell-id=\"".concat(this.id, "\"] input"), function (event) {
          if (_this.default_value !== event.target.value) {
            var $unique_radio_repeater_inputs = _this.$repeater_field.find("[data-cell-id=\"".concat(_this.id, "\"] input[value=\"").concat(_this.default_value, "\"]"));

            // Disable all unique inpus.
            $unique_radio_repeater_inputs.prop('checked', true);

            // Reenable the current input.
            event.target.checked = true;
          }
        });
      }
    }, {
      key: "get_default_value_from_repeater_cell_classes",
      value: function get_default_value_from_repeater_cell_classes() {
        return this.repeater_cell_classes.replace(/^.*unique-default-is-([^\s]+).*$/, '$1');
      }
    }]);
  }();
  var init_all_unique_radio_field_by_form_id = function init_all_unique_radio_field_by_form_id(form_id) {
    var $unique_radio_repeater_cell = $("#gform_wrapper_".concat(form_id, " .gfield_repeater_cell.gf-unique-radio-field-value"));
    if (!$unique_radio_repeater_cell.length) {
      // BAIL, no unique field.
      return;
    }
    var initialised_field_ids = [];
    $unique_radio_repeater_cell.each(function () {
      var $cell = $(this);
      var radio_id = $cell.data('cell-id');
      if (-1 !== initialised_field_ids.indexOf(radio_id)) {
        // BAIL, already initialised.
        return;
      }
      initialised_field_ids.push(radio_id);
      new Repeater_Radio_With_Unique_Value($cell, radio_id);
    });
  };
  $(document).on('gform_post_render', function (event, form_id, current_page) {
    init_all_unique_radio_field_by_form_id(form_id);
  });
})(jQuery);